"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://reference.opcfoundation.org/v104/Core/DataTypes/SecurityTokenRequestType/
exports.SecurityTokenRequestTypeIssue = 0x0;
exports.SecurityTokenRequestTypeRenew = 0x1;
